import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import properties from '../../../modules/ajio-util/properties';
import Logo from '../Logo';

import styles from './error.module.pcss';
import { segmentEventPush } from '../../../modules/ga/GTMdatalayer';

interface ErrorBoundaryProps {
  errorCode: string | number | undefined;
}

const cx = classNames.bind(styles);
const ErrorComponent = (props: ErrorBoundaryProps): JSX.Element => {
  useEffect(() => {
    const bannerPh = document.getElementById('bannerPlaceholder');
    const banner =
      document.getElementById('dynamicBanner') || document.getElementById('pdpPageBanner');
    const headerPh = document.getElementById('headerPlaceholder');
    const header = document.getElementById('pdp-header');
  
    if (bannerPh && banner) {
      // Find the parent of the banner
      const bannerParent = banner.parentNode;
  
      if (bannerParent) {
        // Append bannerPh to the banner's parent
        bannerParent.insertBefore(bannerPh, banner);
  
        // Replace bannerPh with banner
        bannerPh.replaceWith(banner);
      }
    } else if (bannerPh) {
      // If banner is not rendered, remove the shimmer
      bannerPh.remove();
    }
  
    if (headerPh && header) {
      // Find the parent of the header
      const headerParent = header.parentNode;
  
      if (headerParent) {
        // Append headerPh to the header's parent
        headerParent.insertBefore(headerPh, header);
  
        // Replace headerPh with header
        headerPh.replaceWith(header);
      }
    } else if (headerPh) {
      // If header is not rendered, remove the shimmer
      headerPh.remove();
    }


    segmentEventPush({
      event:'Page Load Error',
      screen_name: 'Error Component',
      error_description: errorCode
    });

  }, []);
  
  const { errorCode } = props;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const baseUrl: string = properties.getProperty('imageBaseUrl');
  // eslint-disable-next-line eqeqeq
  if (errorCode == 503) {
    // You can render any custom fallback UI
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return (
      <div className={cx('errorContainer')}>
        <a href="/">
          <Logo />
        </a>
        <img
          src={`${baseUrl}/static/img/HangerPage.jpg`}
          alt="hangerImage"
          width="264"
          height="204"
          alt='Hang in there image'
        />
        <div className="message_one">We will be right back!</div>
        <div className="message_two">
          Whoops. That just happened. We’re fixing this & will be with you soon!
        </div>
      </div>
    );
  }
  return (
    <a href="/">
      <img
        src={`${baseUrl}/static/img/404_m.jpg`}
        alt="Page not available image"
        className={cx('error404')}
      />
    </a>
  );
};

export default ErrorComponent;
